<template>
  <section class="contact-section py-5">
    <div
      class="container"
      data-aos="fade-up"
      data-aos-anchor-placement="top-center"
    >
      <addres-pages :-addres="addres" />
      <div class="row mt-5 h-100 map">
        <div class="col-12 col-md-6 d-flex flex-column justify-content-center">
          <p class="contact-item">
            <strong> <FontAwesomeIcon :icon="faMapPin" class="icon" /> </strong>
    {{ add }}
          </p>
          <p class="contact-item">
            <strong><FontAwesomeIcon :icon="faPhone" class="icon" /></strong>
            {{phone}}
          </p>
          <p class="contact-item">
            <strong><FontAwesomeIcon :icon="faEnvelope" class="icon" /></strong>
            {{ email }}
          </p>
        </div>

        <div class="col-12 col-md-6 mb-4 mb-md-0">
          <iframe
            class="contact-map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.823123456789!2d55.270782315!3d25.204849783!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f434567890ab%3A0xabcdef123456!2sDubai%2C%20United%20Arab%20Emirates!5e0!3m2!1sar!2sae!4v1700000000000"
            width="100%"
            height="650"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import AddresPages from "@/components/AddresPages.vue";
import {
  faMapPin,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { ref, onMounted } from "vue";

const addres = "إتصل بنا";
const phone = ref("");
const add = ref("");
const email = ref("");

onMounted(function () {
  fetch("/data.json")
    .then((res) => res.json())
    .then((data) => {
      phone.value = data.phone;
      add.value = data.address;
      email.value = data.email;
    })
    .catch((err) => console.error(err));
});
</script>

<style scoped>
.contact-section {
  background-color: #f8f9fa;
  min-height: 100vh;
}
.icon {
  padding: 4px;
  background-color: #80d0c7;
  border-radius: 50%;
  margin: 0 10px;
}
.contact-title {
  color: #80d0c7;
  font-weight: 700;
}

.contact-item {
  color: #13547a;
  font-size: 18px;
  margin-bottom: 10px;
}

.contact-map {
  border-radius: 12px;
  width: 100%;
  height: 100%;
}
</style>
